const WINDOWS_RESERVED_NAME =
  /^(?:con|prn|aux|nul|com[1-9]|lpt[1-9])(?:\..*)?$/i
const WINDOWS_FORBIDDEN_CHARACTER = /[<>:"|?*\u0000-\u001f]/

/**
 * Asset paths are shared by Windows, the generated H5 content tree, and URLs.
 * This intentionally uses the strict portable subset instead of host-specific
 * path parsing, including protection from NTFS alternate data streams.
 */
export function isPortableMediaPath(value: string): boolean {
  if (
    value === '' ||
    value.includes('\\') ||
    value.startsWith('/') ||
    /^[a-z]:/i.test(value)
  ) {
    return false
  }

  const segments = value.split('/')
  return segments.every(
    (segment) =>
      segment !== '' &&
      segment !== '.' &&
      segment !== '..' &&
      !WINDOWS_FORBIDDEN_CHARACTER.test(segment) &&
      !/[. ]$/.test(segment) &&
      !WINDOWS_RESERVED_NAME.test(segment)
  )
}
